var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    {
      staticClass: "entry-layout-content",
      class: [
        _vm.$route.params.name &&
          "entry-layout-content_by_" + _vm.$route.params.name,
      ],
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }